import { render, staticRenderFns } from "./ProjectDocumentApprovalStatus.vue?vue&type=template&id=cd7a4de4"
import script from "./ProjectDocumentApprovalStatus.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentApprovalStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports